import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const CompareContext = createContext(null);
const STORAGE_KEY = "carhive_compare_v1";
export const COMPARE_MAX = 3;

export function CompareProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.slice(0, COMPARE_MAX) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(ids)); }
    catch { /* ignore quota errors */ }
  }, [ids]);

  const has = useCallback((id) => ids.includes(id), [ids]);

  const toggle = useCallback((id) => {
    if (!id) return { added: false, reason: "no-id" };
    if (ids.includes(id)) {
      setIds((prev) => prev.filter((x) => x !== id));
      return { added: false };
    }
    if (ids.length >= COMPARE_MAX) {
      return { added: false, reason: "max" };
    }
    setIds((prev) => [...prev, id]);
    return { added: true };
  }, [ids]);

  const remove = useCallback((id) => setIds((prev) => prev.filter((x) => x !== id)), []);
  const clear = useCallback(() => setIds([]), []);

  const value = { ids, count: ids.length, has, toggle, remove, clear, max: COMPARE_MAX };
  return <CompareContext.Provider value={value}>{children}</CompareContext.Provider>;
}

export function useCompare() {
  const ctx = useContext(CompareContext);
  if (!ctx) throw new Error("useCompare must be used inside <CompareProvider>");
  return ctx;
}
